<template>
  <layout
    title="Gruppenreisen 2026/2027"
    :banner="$page.props.banner"
    h1="Gruppenreisen"
    metaDescription="Ihr seid eine Gruppe ab 8 Personen und möchtet gemeinsam in den Skiurlaub? Sendet uns eure unverbindliche Anfrage für die Wintersaison 2026/2027."
    metaKeywords="SCOL, SCOL Skireisen, Gruppenreisen, Skireise Gruppe, Gruppenreise Ski, Skiurlaub Gruppe, Gruppenreise anfragen"
  >
    <section id="gruppenreisen-intro" class="scol-section bg-light">
      <div class="container-fluid py-sm-4 py-md-0">
        <div class="text-center">
          <h2 class="h3">Gruppenreisen 2026/2027 – ab 8 Personen</h2>
          <p class="mt-3">
            Ihr möchtet als Gruppe gemeinsam in den Skiurlaub? Ab 8 Personen
            stellen wir euch gerne ein individuelles Angebot zusammen. Sendet uns
            einfach eure unverbindliche Anfrage – wir melden uns bei euch.
          </p>
        </div>
      </div>
    </section>
    <section id="gruppenreisen-form" class="scol-section">
      <div class="scol-section-caption">
        <h2>Anfrage Gruppenreise</h2>
      </div>
      <div class="container container-small">
        <div class="row justify-content-center">
          <div class="col-12">
            <simple-inquiry-form post-route="group-travel.store" detailed />
          </div>
        </div>
      </div>
    </section>
  </layout>
</template>

<script>
import Layout from "./Layouts/Standard";
import SimpleInquiryForm from "../Components/Scol/SimpleInquiryForm.vue";

export default {
  components: {
    Layout,
    SimpleInquiryForm,
  },
};
</script>
